/* eslint-disable react-hooks/exhaustive-deps */
import { Divider } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { showNotification } from 'src/core/helpers'
import { CustomCard, CustomTable } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { stockAlertListColumns } from 'src/core/table-columns'
import StockAlertListHeader from '../StockAlertListHeader/StockAlertListHeader'
import {
  allProjectsIntegrationSelector,
  deleteStockAlertSelector,
  stockAlertListSelector,
  resetStockAlertDelete,
} from 'src/features'
import { StockAlert } from 'src/core/models'

const StockAlertPageContent = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const {
    loading: loadingList,
    data: stockAlertData
  } = useAppSelector(stockAlertListSelector)

  const {
    loading: loadingDelete,
    success: successDelete
  } = useAppSelector(deleteStockAlertSelector)

  const {
    loading: loadingProjects,
  } = useAppSelector(allProjectsIntegrationSelector)

  useEffect(() => {
    if (successDelete) {
      showNotification('success', t('general.OperationSuccess'))
      dispatch(resetStockAlertDelete())
    }
  }, [successDelete])

  const isLoading = loadingList || loadingDelete || loadingProjects

  return (
    <CustomCard loading={isLoading}>
      <StockAlertListHeader stockAlertsLength={stockAlertData.length} />
      <Divider />
      <CustomTable
        rowKey={(stockAlert: StockAlert) => stockAlert.id}
        columns={stockAlertListColumns}
        dataSource={stockAlertData}
      />
    </CustomCard>
  )
}

export default StockAlertPageContent
